#import "../../../graphql/fragments/coordinates-fragment.graphql"
#import "../../../graphql/fragments/location-weather-fragment.graphql"

query GetAccountLocationData($id: ID!) {
    account(id: $id) {
        id
        postalAddresses {
            primary {
                location {
                    coordinates {
                        ...CoordinatesFragment
                    }
                    weather {
                        ...LocationWeatherFragment
                    }
                }
            }
        }
    }
}
